import { render, staticRenderFns } from "./setup-user.vue?vue&type=template&id=4427e6ad&"
import script from "./setup-user.vue?vue&type=script&lang=js&"
export * from "./setup-user.vue?vue&type=script&lang=js&"
import style0 from "./setup-user.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "setup-user.vue"
export default component.exports